/**
 * Permissions Configuration
 * Defines role-based access control for entity actions
 */

export const permissions = {
	course: {
		actions: {
			delete: {
				allowedRoles: ['admin'] as const,
			},
			dashboardDelete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
			publish: {
				allowedRoles: ['admin'] as const,
			},
			unpublish: {
				allowedRoles: ['admin'] as const,
			},
			duplicate: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
			export: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
			createStudyPlan: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
			createCourseDiagram: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
			createInstance: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
		},
	},
	module: {
		actions: {
			createModule: {
				allowedRoles: ['instructor', 'admin'] as const,
				ownerOnly: true,
			},
			delete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
			cardDelete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
		},
	},
	topic: {
		actions: {
			topicActionsDelete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
			collectResources: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
			createDiagram: {
				allowedRoles: ['free', 'subscriber', 'instructor', 'admin'] as const,
			},
		},
	},
	resource: {
		actions: {
			delete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
			resourceCardDelete: {
				allowedRoles: ['admin', 'instructor'] as const,
				ownerOnly: true,
			},
		},
	},
} as const

export type Permissions = typeof permissions
